export const TOKEN_NAME = "admin_token";
export const PageSize = 10;
export const LOGIN_PATH = "login";
